import { Action } from '../actions/ActionInterface';
import { ActionTypes } from '../actions/ActionTypes';

export interface UiState {
  activeTab: string;
  hasActiveFilters: boolean;
  selectedBeerId: string | null;
  filterBarHeight: number;
}

const initialState: UiState = {
  activeTab: '0', // '0' = All Beers, '1' = My Drinks, '2' = Tasting List
  hasActiveFilters: false, // Whether there are active filters
  selectedBeerId: null, // Currently selected beer for action bar
  filterBarHeight: 0, // Height of the active filters bar in pixels
};

/**
 * UI state reducer
 * Handles all actions related to UI state
 * Following Single Responsibility Principle by focusing only on UI state
 */
export function uiStateReducer(state: UiState = initialState, action: Action): UiState {
  // Use the action's execute method if available (Command pattern)
  // Check if execute exists without causing TypeScript errors
  if (action && typeof (action as any).execute === 'function') {
    // The execute method expects the full state, so we need to adapt it
    const fullState = { ui: state } as any;
    const newState = action.execute(fullState);
    
    // Extract only the ui property this reducer is responsible for
    return newState.ui;
  }
  
  // Fallback to traditional switch statement for backward compatibility
  switch (action.type) {
    case ActionTypes.SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload || 'all',
      };
    
    case ActionTypes.SET_HAS_ACTIVE_FILTERS:
      return {
        ...state,
        hasActiveFilters: action.payload,
      };
    
    case ActionTypes.SET_SELECTED_BEER:
      return {
        ...state,
        selectedBeerId: action.payload,
      };
    
    case ActionTypes.CLEAR_SELECTED_BEER:
      return {
        ...state,
        selectedBeerId: null,
      };
    
    case ActionTypes.SET_FILTER_BAR_HEIGHT:
      return {
        ...state,
        filterBarHeight: action.payload,
      };
      
    default:
      return state;
  }
}
